import React from 'react';
import ServiceCategoryPage from './ServiceCategoryPage';

const TravelAndHolidayLetters = () => {
  return (
    <ServiceCategoryPage
      category="Travel & Holiday Letters"
      title="Travel & Holiday Letters"
      intro="Ensure you're ready for your trip with our same-day travel and holiday letters. From fit-to-fly certificates to holiday cancellation letters, all reviewed by UK doctors."
    />
  );
};

export default TravelAndHolidayLetters;